module.exports = __webpack_public_path__ + "static/media/splash_logo.12c58c22.png";